export default (props, e) => {
  e.stopPropagation();
  const {
    actionClass,
    actionTarget,
    separator = ';',
  } = props;
  const {target} = e;

  if (actionTarget) {
    const targetSet = actionTarget.split(separator);
    targetSet.forEach(element => document.querySelector(element).classList.toggle(actionClass));
  }
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/webActions/toggleClass.js